import { defineMessages } from 'react-intl';

export default defineMessages({
    // signUp: {
    //     id: 'auth.components.LockLogin.Sign up',
    //     // defaultMessage: 'Sign up'
    //     defaultMessage: 'Register'
    // },
    // doYouHavePolicy: {
    //     id: 'auth.components.LockLogin.Do you have a policy with us but don’t have an account?',
    //     // defaultMessage: 'Do you have a policy with us but don’t have an account?'
    //     defaultMessage: 'Don\'t have an account?'
    // },
    needHelpText: {
        id: 'auth.components.LockLogin.Need help? Contact us by phone',
        defaultMessage: 'Need help? Contact us by phone'
    },
});
